var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"24c6c0a7e2ee1ef4f45f8dab78c15a4b8744faed"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"24c6c0a7e2ee1ef4f45f8dab78c15a4b8744faed"};
      